import React from 'react';
import cn from 'classnames';

import styles from './Steps.module.css';

const ImportantNote = (props) => {
  const { 
    onClick, 
    message, 
    className,
    title = 'Important note',
  } = props;

  return (
    <div className={cn(styles.noteWrapper, className)}>
      <div className={styles.importantNoteWrapper}>
        <div className={styles.strictMenu}>
          <div className={styles.strictTitle}>
            {title}
          </div>
          <div className={styles.strictSubtitle}>
            {message}
          </div>
        </div>
        <button
          className="green-button"
          onClick={onClick}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ImportantNote;